<template>
  <div class="select-wrp">
    <transition name="fade">
      <MyPopup v-if="show" :goodsItem="goodsItem" @close="handleClose" @handleAddShop="handleAddShop"></MyPopup>
    </transition>
    <div class="content">
    <div class="header">
      <van-nav-bar
        title="商品列表"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <div class="search-ipt">
        <i class="huisuiyunfont">&#xe61d;</i>
        <input type="text" :value="searchKey" @change="handleQueryChange" placeholder="输入商品名称以搜索" class="search-input" @focus="handleSearchFocus"/>
        <i class="iconfont" @click="handleCloseSearch" v-show="searchShow">{{'\ue60b'}}</i>
        <van-button class="search-button" type="info" v-show="searchShow" @click="search">搜 索</van-button>
      </div>
    </div>
    <section>
       <div v-if="![...searchData].length > 0" >
        <div class="showNoGoods">
          <i class="huixiaopiaofont">&#xe602;</i>
          <div>请新增商品</div>
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loadingnew"
          :finished="finished"
          finished-text=""
          :immediate-check="false"
          @load="onLoad"
        >
          <div v-if="[...searchData].length > 0" class="goodsList">
            <van-swipe-cell v-for="(item,index) in searchData" :key="index" :ref="'swipecell'+item.id" :name="item.id"  >
              <div class="goods-card" @click="handleGoodsClick(item)">
                <div class="goods-card-inner">
                  <div class="commodity-name">
                    {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
                  </div>
                  <div class="specification">
                    <div class="specification-item">
                      <span class="label">单位:</span>
                      <span class="value">{{item.unit ? item.unit : '--'}}</span>
                    </div>
                    <div class="specification-item">
                      <span class="label">税编简称:</span>
                      <span class="value">{{item.shortName ? item.shortName : '--'}}</span>
                    </div>
                  </div>
                  <div class="specification">
                    <div class="specification-item">
                      <span class="label">税率:</span>
                      <span class="value">{{item.taxRate ? `${item.taxRate * 100}%` : '--'}}</span>
                    </div>
                    <div class="specification-item">
                      <span class="label">商品规格:</span>
                      <span class="value">{{item.specification ? item.specification : '--'}}</span>
                    </div>
                  </div>
                  <div class="recommend" v-if="item.order === 1 && !searchKey">置顶</div>
                </div>
              </div>
              <template #right>
                <van-button square text="置顶" type="primary" class="top-button" @click="setDefaultGoods(item)"/>
              </template>
            </van-swipe-cell>
          </div>
      </van-list>
      </van-pull-refresh>
    </section>
    </div>
    <div class="float-btn" @click="addGoods">新增商品</div>
  </div>
</template>

<script>
import {
  Field,
  Button,
  Popup,
  Notify,
  Toast,
  NavBar,
  Switch,
  PullRefresh,
  List,
  SwipeCell
} from 'vant'
import {
  deepCopy,
  onCount,
  getQuery
} from '@utils/basicUtil'
import '@utils/baseProto.js'
import { invoiceRequest } from '@services'
// import {
//   TAX_RATE
// } from '@assets/config'
import MyPopup from '@/components/Popup'
export default {
  data () {
    return {
      show: false,
      loading: false,
      showInfo: false,
      selectGoods: [],
      loadingnew: false,
      refreshing: false,
      searchShow: false,
      ballShow: true,
      finished: false,
      goodsItem: {},
      goodsMessage: [],
      length: 0,
      nowGoodsMessage: [],
      barRightTitle: '精简模式',
      editType: '',
      editItemIndex: null,
      searchKey: '',
      tableData: [],
      total: 0,
      searchData: [],
      edit: {
        visible: false,
        data: {}
      },
      bgTimer: null,
      moneyError: {
        visible: false,
        selectMoney: 0
      },
      companyId: '',
      current: 1,
      size: 20,
      formData: {},
      source: ''
    }
  },
  computed: {

  },
  mounted () {
    this.initSelectData()
  },
  methods: {
    onLoad () {
      this.loadingGoodList()
    },
    handleCloseSearch () {
      this.searchShow = false
      this.searchKey = ''
      this.initSelectData()
    },
    handleQueryChange (e) {
      this.searchKey = e.target.value
    },
    // handleSearchBlur () {
    //   this.searchShow = false
    // },
    handleSearchFocus () {
      this.searchShow = true
    },
    handleGoodsClick (item) {
      // this.show = true
      // this.goodsItem = item
      this.$router.push(`/user-center/goodsList/page?id=${item.id}`)
    },
    addGoods () {
      this.$router.push(`/user-center/goodsList/page`)
    },
    async setDefaultGoods (item) {
      const data = await invoiceRequest.goods.setDefaultGoods({ id: item.id })
      if (data.success) {
        this.onRefresh()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onRefresh () {
      this.finished = false // 下拉时候是否加载的状态
      this.current = 1
      this.tableData = []
      this.searchData = [] // 卡片数据
      this.initSelectData()
    },
    handleClose () {
      this.show = false
    },
    onClickLeft () {
      if (this.oldNowGoodsMessage) {
        sessionStorage.nowGoodsMessage = JSON.stringify(this.oldNowGoodsMessage)
        sessionStorage.goods = JSON.stringify(this.oldNowGoodsMessage)
      } else {
        sessionStorage.nowGoodsMessage = []
        sessionStorage.goods = []
      }
      this.$router.go(-1)
    },
    onClickRight () {
      if (this.barRightTitle === '精简模式') {
        this.barRightTitle = '复杂模式'
      } else {
        this.barRightTitle = '精简模式'
      }
    },
    convertPrice (price) {
      const priceStr = String(price)
      if (priceStr.length > 15) {
        return priceStr.substr(0, 15)
      }
      return price
    },
    resetScrollTop () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    calcAmountWithTax (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        price,
        quantity = 1
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      const tempAmountWithTax = onCount.mul(price, quantity)
      let amountWithTax
      if (taxPre === 1 && this.showTaxSign) {
        // 不免税且显示是否含税标示
        amountWithTax = onCount.mul(tempAmountWithTax, (taxSign ? 1 : calcTaxRate))
      }
      return (amountWithTax || tempAmountWithTax).toFixed(2)
    },
    async getGoodsList () {
      // 税编缺失，默认申请开票可以查出来，电票直开默认不查标示为business 存在就不查
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      this.current = 1
      this.size = 20
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        existRevenueCode,
        current: this.current,
        size: this.size,
        status: 0
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            price: this.convertPrice(resPrice || originPrice),
            order: i + 1 + (data.result.current - 1) * data.result.size,
            taxSign: resTaxSign
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        this.tableData = resArr
        this.total = data.result.total
        this.searchData = deepCopy(resArr)
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      if (this.tableData.length === Number(this.total)) {
        this.finished = true
      } else {
        this.finished = false
      }
    },
    search () {
      this.searchData = []
      this.tableData = []
      this.current = 1
      this.size = 20
      this.$nextTick()
      this.getGoodsList()
    },
    async loadingGoodList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      if (this.tableData.length === Number(this.total)) {
        this.finished = true
        this.refreshing = false
        this.loadingnew = false
        return
      }
      this.current = this.current + 1
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        current: this.current,
        size: this.size,
        status: 0,
        existRevenueCode
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign,
            order: i + 1 + (data.result.current - 1) * data.result.size
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        const table = this.tableData
        this.tableData = table.concat(resArr)
        this.searchData = deepCopy(table.concat(resArr))
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      console.log(this.tableData)
      this.loadingnew = false
      Toast.clear()
    },
    async initSelectData (id) {
      console.log('初始化')
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      let existRevenueCode = ''
      let { source } = getQuery()
      if (source === 'business') {
        existRevenueCode = 1
      }
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        current: this.current,
        size: this.size,
        status: 0,
        existRevenueCode
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign,
            order: i + 1 + (data.result.current - 1) * data.result.size
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        this.tableData = resArr
        this.total = data.result.total
        this.searchData = deepCopy(resArr)
      } else {
        if (data.success === false) {
          this.finished = true
          Notify({ type: 'danger', message: data.message })
        }
      }
      Toast.clear()
    }
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Switch.name]: Switch,
    [NavBar.name]: NavBar,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [SwipeCell.name]: SwipeCell,
    MyPopup
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
